
import React from 'react';
import { motion } from 'framer-motion';
import DevelopmentPipeline from './DevelopmentPipeline';

const Timeline = () => {
  return (
    <motion.section 
      className="relative py-0" 
      id="how-we-work"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="relative z-10">
        <div className="max-w-6xl mx-auto px-1 md:px-2">
          <DevelopmentPipeline />
        </div>
      </div>
    </motion.section>
  );
};

export default Timeline;
